import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import BodyRow from './BodyRow'

import './style.scss'

// const areEqual = (prevProps, nextProps) => {
//   console.log(`Angelo Log ~ file: ParentRow.jsx ~ line 11 ~ areEqual ~ prevProps.row`, prevProps.row)
//   console.log(`Angelo Log ~ file: ParentRow.jsx ~ line 11 ~ areEqual ~ nextProps.row`, nextProps.row)
//   return _.isEqual(prevProps.row.children, nextProps.row.children)
// }

const ParentRow = ({ parentNode, expanded, children, onHandleExpand }) => {
  // const newProps = useMemo(() => rowProps, [rowProps])
  const [isExpanded, setExpandedStatus] = useState()

  // const { children: rowChildren, value: parentRowValue } = row

  const handleParentToggle = () => {
    setExpandedStatus(!isExpanded)
    onHandleExpand(!isExpanded)
  }

  useEffect(() => {
    setExpandedStatus(expanded)
  }, [expanded])

  return (
    <div
      className={classnames('fil-table--body-parent', {
        isExpanded
      })}
      aria-label="Parent Row"
    >
      <div className="fil-table--body-parent-row" onClick={handleParentToggle}>
        {!_.isEmpty(children) && (
          <span className="fil-table--body-parent-row-icon">
            <fil-icon size="12" icon={`custom-chevron-${isExpanded ? 'up' : 'down'}`} />
          </span>
        )}
        <BodyRow
          {...parentNode}
          extraClasses={classnames('fil-table--body-parent-row-content', {
            'without-collapse-icon': _.isEmpty(children)
          })}
        />
      </div>

      <div className="fil-table--body-children-rows">
        {children.map((child, childIndex) => (
          <BodyRow extraClasses="fil-table--body-parent-child-row" key={`table_row_${childIndex}`} {...child} />
        ))}
      </div>
    </div>
  )
}

ParentRow.propTypes = {
  parentNode: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  expanded: PropTypes.bool,
  onHandleExpand: PropTypes.func
}

ParentRow.defaultProps = {
  expanded: true,
  onHandleExpand: () => {}
}

export default React.memo(ParentRow)
